import { useIsRegional } from 'common/hooks/region';
import { RegionDropdown } from 'layouts/AppPageTemplate/desktop/DesktopNav/RegionDropdown';
import * as React from 'react';

interface Props {
  title: React.ReactNode;
  description?: React.ReactNode;
  headerRight?: React.ReactNode; // Option to add a component to the right of the header
}

/**
 * Renders a generic header in our new (end of 2022) style with conditional
 * region selector and optional description
 */
export const PageHeader: React.FC<Props> = (props) => {
  const isRegional = useIsRegional();
  return (
    <div>
      <div className="flex items-center justify-between gap-6">
        <div className="flex gap-6 items-center">
          <h3 className="font-medium text-xl text-black">{props.title}</h3>
          {props.headerRight && props.headerRight}
        </div>
        {isRegional && <RegionDropdown />}
      </div>
      {props.description && (
        <div className="text-gray-500 text-lg font-medium">{props.description}</div>
      )}
    </div>
  );
};
PageHeader.displayName = 'PageHeader';
